import React, { useEffect } from 'react'
import { Grid, Card, CardContent } from '@mui/material'
import SideBar from '../../components/admin/SideBar'
import BookedLessonsList from '../../components/admin/BookedLessonsList'
import { useSelector, useDispatch } from 'react-redux'
import { getBookedLessonsForAdmin } from '../../actions/learningScheduleForStudent'

const DashboardAdmin = () => {
  const { bookedLessons } = useSelector(state => state.learningScheduleForStudent)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getBookedLessonsForAdmin())
  }, [dispatch])

  return (
    <Grid container justifyContent='space-around'>
      <Grid item xs={2}><Card>
        <CardContent>
          <Grid container justifyContent='center' alignItems='center' direction='column'>
            <Grid item>
              <SideBar />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      </Grid>

      <Grid item xs={9}>
        {bookedLessons.length > 0 && <BookedLessonsList bookedLessons={bookedLessons} />}
      </Grid>
    </Grid>
  );
}

export default DashboardAdmin
